import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["innerRef"];
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { Dropdown, DropdownItem } from '../../../../components/Dropdown';
import Icon from '../../../../components/Icon';
import styles from './EventCategoryDropdown.m.sass';
export var EVENT_CATEGORIES = {
  ALL: 'All Events',
  JOB_UPDATES: 'Job Updates',
  TASK_UPDATES: 'Task Updates'
};
var EventCategoryDropdown = function EventCategoryDropdown(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    children = _ref.children,
    big = _ref.big;
  var makeButton = function makeButton(_ref2) {
    var innerRef = _ref2.innerRef,
      buttonProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement("a", _extends({
      className: cx(styles.button, big && styles.big)
    }, buttonProps, {
      ref: innerRef
    }), EVENT_CATEGORIES[value], /*#__PURE__*/React.createElement(Icon, {
      material: true,
      size: big ? 24 : 18,
      name: "arrow drop down"
    }));
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    button: makeButton,
    topOffset: -10
  }, Object.keys(EVENT_CATEGORIES).map(function (key) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      active: value === key,
      key: key,
      onClick: function onClick() {
        return onChange(key);
      }
    }, EVENT_CATEGORIES[key]);
  }));
};
export default observer(EventCategoryDropdown);
//# sourceMappingURL=index.js.map
